<!--
    Styles
-->

<style>


    /* main */

    .p-property {
        position: relative;
        min-width: 600px;
        padding: 40px 80px 35px 80px;
        background: var(--cl-white);
        overflow-x: hidden;
    }

    /* loader */

    .p-property .loader {
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        overflow: hidden;
    }

    /* spinner */

    .p-property .spinner {
        width: 32px;
        height: 32px;
        margin: auto;
    }

    /* close */

    .p-property .close {
        position: absolute;
        width: 24px;
        height: 24px;
        top: 16px;
        right: 16px;
    }
    .p-property .close svg {
        fill: var(--cl-gray);
    }

    /* headings */

    .p-property h1 {
        margin: 0 0 20px 0;
    }
    .p-property .caption {
        margin-bottom: 30px;
    }

    /* rows */

    .p-property .row {
        height: 40px;
        width: 100%; /* to be overriden */
    }
    .p-property .row + .row {
        margin-top: 20px;
    }
    .p-property .row.half {
        width: 45%;
    }
    .p-property .row > .label {
        width: 100px;
        min-width: 100px;
    }
    .p-property .row .unit {
        width: 30px;
        min-width: 30px;
        margin-left: 10px;
    }

    /* select */

    .p-property .row .ui-dropdown {
        flex: 1 1 auto;
        margin: 10px 0;
    }
    .p-property .row input[type=text],
    .p-property .row input[type=number],
    .p-property .row .ui-dropdown .ui-select {
        z-index: 1;
        border: 1px solid var(--cl-gray);
        border-radius: 3px;
        padding: 0 12px;
        height: 42px;
        min-width: 0;
    }
    .p-property .row .ui-dropdown .ui-select.active {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }
    .p-property .row .ui-dropdown .dropdown {
        background: var(--cl-white);
        max-height: 150px;
        border-top: 0;
        z-index: 2;
    }
    .p-property .row .ui-dropdown .dropdown .option {
        height: 40px;
    }
    .p-property .row .ui-dropdown .dropdown .option:hover {
        background: var(--cl-blue-light);
    }
    .p-property .row .ui-radio + .ui-radio {
        margin-left: 30px;
    }
    .p-property .next svg {
        margin: 0;
    }

    /* fields */

    .p-property .fields {
        width: 100%;
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    /* buttons */

    .p-property .btn.inactive {
        pointer-events: none;
    }
    .p-property .buttons {
        margin-top: 40px;
    }
    .p-property .buttons .btn + .btn {
        margin-left: 20px;
    }


</style>



<!--
    Template
-->

<template>
    <div class="p-property" :style="{width}">

        <!-- loader -->

        <div class="loader u-stretch" v-show="!!loading">
            <ui-loader class="ui-loader" />
        </div>


        <!-- close -->

        <a aria-label="閉じる" class="close cl-placeholder" @click="$popup.hide()">
            <icon-close />
        </a>


        <!-- titles -->

        <h1 class="h2 t-center">{{ title }}</h1>

        <div class="caption t12 t-center" v-if="!type">
            物件種別を選択してください。
        </div>
        <div class="caption t12 t-center" v-else>
            物件の情報を入力し、保存するボタンをクリックしてください。
        </div>

        <ui-spinner class="spinner" v-show="!!loading" />


        <!-- form -->

        <div class="form" v-show="!loading">

            <!-- building type -->

            <div class="row u-row">
                <span class="w5 label">物件種別</span>
                <ui-dropdown class="u-flex" v-slot="{active, toggle}">
                    <ui-select :class="{active}" :label="type || '選択してください'" @click.native="toggle" />
                    <ui-options v-show="active" :options="types" @update="select" />
                </ui-dropdown>
            </div>

            <div class="fields" v-if="type && model">

                <!-- mutual fields -->

                <!--
                <div class="row u-row">
                    <span class="w5 label">取引種別</span>
                    <div class="u-row field">
                        <ui-radio label="売買" :checked="model.type === '売買'" @change="model.type = '売買'" />
                        <ui-radio label="賃貸" :checked="model.type === '賃貸'" @change="model.type = '賃貸'" />
                    </div>
                </div>
                -->

                <div class="row half u-row">
                    <span class="w5 label">募集･成約時期</span>
                    <ui-date :value="model.dealtAt" @update="model.dealtAt = $event" />
                    <span class="unit" />
                </div>


                <!-- fields -->

                <div
                    class="row u-row"
                    v-for="{get, set, width, wrap, ...input} of inputs"
                    :key="input.name"
                    :class="{wrap}"
                    :style="{width, marginRight: wrap ? `calc(100% - ${width})` : 0}"
                >

                    <!-- label -->

                    <span class="w5 label">{{ input.label }}</span>


                    <!-- select -->

                    <ui-dropdown
                        v-if="input.type === 'select'"
                        class="u-flex"
                        v-slot="{active, toggle}"
                    >
                        <ui-select :class="{active}" :label="model[input.name] || input.placeholder" @click.native="toggle" />
                        <ui-options v-show="active" :options="input.options" @update="model[input.name] = $event" />
                    </ui-dropdown>


                    <!-- date -->

                    <ui-date
                        v-else-if="input.type === 'date'"
                        :value="model[input.name]"
                        @update="model[input.name] = $event"
                    />


                    <!-- others -->

                    <input
                        v-else
                        class="i-box u-flex field"
                        :type="input.type"
                        :value="get(model[input.name])"
                        :step="input.step || 1"
                        @input="model[input.name] = set($event.target.value)"
                        :placeholder="input.placeholder"
                    >


                    <!-- unit -->

                    <span v-if="input.unit" class="unit">{{ input.unit }}</span>

                </div>
            </div>


            <!-- controls -->

            <div class="u-row buttons">
                <a class="btn u-flex dark" @click="$popup.hide()">
                    閉じる
                </a>
                <a class="btn u-flex primary" :class="{inactive: !type}" @click.stop="save">
                    <icon-save />
                    <span>保存する</span>
                </a>
            </div>
        </div>

    </div>
</template>

<!--
    Scripts
-->

<script>

    import API from '@/common/modules/api'
    import {flatten, expand} from '@/common/helpers/nested'

    import fields from '@/common/configs/fields'
    import types from '@/common/configs/types'
    import structures from '@/common/configs/structures'
    import floorPlans from '@/common/configs/floorPlans'

    import uiLoader from '@/components/shared/ui/loader.vue'
    import uiSpinner from '@/components/shared/ui/spinner.vue'
    import uiDropdown from '@/components/shared/ui/dropdown.vue'
    import uiSelect from '@/components/shared/ui/select.vue'
    import uiOptions from '@/components/shared/ui/options.vue'
    import uiDate from '@/components/shared/ui/date.vue'
    import iconClose from '@/assets/icons/close.svg'
    import iconSave from '@/assets/icons/save.svg'


    /* configs */

    const inputs = {
        'building.name': {
            type: 'text',
            placeholder: '〇〇マンション'
        },
        'building.address': {
            type: 'text',
            placeholder: '都道府県・市区町村・町名・番地'
        },
        'roomNumber': {
            type: 'text',
            width: '45%',
            placeholder: '101'
        },
        'floor': {
            type: 'number',
            width: '45%',
            placeholder: '1'
        },
        'building.floorsCount': {
            type: 'number',
            width: '45%',
            placeholder: '1'
        },
        'building.structure': {
            type: 'select',
            options: structures,
            placeholder: '選択してください'
        },
        'dealPrice': {
            type: 'number',
            width: '45%',
            placeholder: '00.00',
            wrap: true,
            get: v => v / 1e4,
            set: v => v * 1e4,
            step: 'any',
            unit: '万円'
        },
        'sqm': {
            type: 'number',
            width: '45%',
            placeholder: '00',
            step: 'any',
            unit: 'm²'
        },
        'landSqm': {
            type: 'number',
            width: '45%',
            placeholder: '00',
            wrap: true,
            step: 'any',
            unit: 'm²'
        },
        'floorPlan': {
            type: 'select',
            width: '45%',
            options: floorPlans,
            placeholder: '選択'
        },
        'building.builtAt': {
            type: 'date',
            width: '45%',
            placeholder: 'YYYY/MM',
            unit: ' ' // empty
        }
    };

    const titles = {
        new: '物件の追加',
        edit: '物件の編集'
    };


    /* utils */

    const filter = (obj, keys = []) => keys
        .reduce((acc, key) => Object.assign(acc, {[key]: obj[key]}), {});


    export default {

        components: {
            uiLoader,
            uiSpinner,
            uiDropdown,
            uiSelect,
            uiOptions,
            uiDate,
            iconClose,
            iconSave
        },

        props: ['id'],

        created () {
            Object.assign(this, {types});
        },

        data () {
            return {
                loading: false,
                type: null,
                model: null
            }
        },

        computed: {

            mode () {
                return this.id ? 'edit' : 'new';
            },

            width () {
                return this.type ? '680px' : '500px';
            },

            title () {
                return titles[this.mode];
            },

            inputs () {
                return this.type && types[this.type].extra
                    .map(name => ({
                        name,
                        get: v => v,
                        set: v => v,
                        width: '100%',
                        label: fields[name],
                        ...inputs[name]
                    }));
            },

            keys () {
                return Object.keys(inputs)
                    .concat('building.type', 'type', 'dealtAt');
            }

        },

        methods: {

            api (...args) {
                return this.loading = API(...args)
                    .finally(() => this.loading = null);
            },

            select (type) {
                this.type = type;
                this.model = {};
            },

            load (data) {
                this.type = data.building.type;
                this.model = filter(flatten(data), this.keys);
            },

            save () {
                const data = expand(this.model);
                if (data.building) data.building.type = this.type;
                if (this.id) this.api('update', this.id, data);
                else this.api('create', data);
                this.loading
                    .then(() => this.$popup.hide(true))
                    .catch(() => this.$popup.hide(false));
            }

        },

        mounted () {
            if (this.id) {
                this.api('get', this.id)
                    .then(({data}) => this.load(data));
            }
        },

        destroy () {
            this.loading && API.abort(this.loading);
        }

    }

</script>
